export const LINKEDIN_SELF_PROFILE_URL = 'https://www.linkedin.com/me/';

/**
 * Converts the LinkedIn profile value saved on a CV into a universal HTTPS
 * link. HTTPS lets iOS and Android open the LinkedIn app when installed and
 * keeps the browser as the fallback when it is not.
 */
export function normalizeLinkedInProfileUrl(
  value?: string | null,
): string | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;

  const candidate = /^https?:\/\//i.test(trimmed)
    ? trimmed
    : `https://${trimmed}`;

  try {
    const url = new URL(candidate);
    const hostname = url.hostname.toLowerCase();
    const isLinkedInHost =
      hostname === 'linkedin.com' || hostname.endsWith('.linkedin.com');
    const [, section, profileSlug] = url.pathname.split('/');

    if (
      !isLinkedInHost ||
      section?.toLowerCase() !== 'in' ||
      !profileSlug ||
      url.username ||
      url.password ||
      url.port
    ) {
      return null;
    }

    url.protocol = 'https:';
    return url.toString();
  } catch {
    return null;
  }
}

/**
 * Prefer the profile URL already saved on the CV. LinkedIn's supported `/me/`
 * route is the signed-in member fallback when no usable public URL is saved.
 */
export function resolveLinkedInProfileUrl(value?: string | null): string {
  return normalizeLinkedInProfileUrl(value) ?? LINKEDIN_SELF_PROFILE_URL;
}
